/**
 * @file LoginBackground.jsx
 * @author Archana
 * @date 2024-10-25
 * @description Component used in Candidate auth pages.
 */
import { Box } from "@mui/material";
import { images } from "../../assets";

export const AuthCandidateBackground = () => (
  <Box
    sx={{
      position: "absolute",
      right: 0,
      height: "100%",
      width: "70%",
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${images.loginCandidateBg})`,
    }}
  />
);
